import { Fragment } from "react";

import { TextInput } from "@dzambalaorg/mui-inputs-core";

import { WaitListItem } from "./wait-list-item";
import { WaitListListInput } from "./wait-list-list-input";

export { waitlistJoinValidationSchema } from "./validation";

export const WaitListDialogForm = () => {
  return (
    <Fragment>
      <WaitListItem />
      <TextInput name="account" readOnly />
      <WaitListListInput name="listId" />
    </Fragment>
  );
};
